import type { GlassMode } from '@typings/glass';

import type { SliceCreator } from '../types';

export interface GlassSlice {
  /**
   * How glass renders on this device. Resolved by GlassManager before the
   * first render, and changed afterwards only if the visitor toggles
   * reduced transparency in their OS settings.
   */
  glassMode: GlassMode;

  setGlassMode: (mode: GlassMode) => void;
}

export const createGlassSlice: SliceCreator<GlassSlice> = (set) => ({
  /* Pessimistic default: frost works everywhere glass works at all. */
  glassMode: 'frost',

  setGlassMode: (glassMode) => {
    set((state) => (state.glassMode === glassMode ? state : { glassMode }));
  },
});
